import { ApiFlightType } from '@ve/types/api/ApiFlightType';
import { FlightType } from '@ve/types/FlightType';

export default (flightType: ApiFlightType): FlightType => (flightType === 'regular' ? 2 : 1);